
import globalHook, { Store } from 'use-global-hook';
import { roles } from '../../auth/roles';

/* InitalStates */
export const initialCommonState: ICommonStore = {
  userInfo: {},
  activeTab: undefined,
  tabLength: 0,
  selectedSalesOrderIds: [],
};

/* Actions */
export const commonActions: object = {
  clearState: (store: Store<ICommonStore, ICommonActions>, data: Partial<ICommonStore>) => {
    store.setState({ ...store.state, ...data });
  },
  setUserInfo: (store: Store<ICommonStore, ICommonActions>, userInfo: any) => {
    store.setState({ ...store.state, userInfo });
  },
  userHasRole: (store: Store<ICommonStore, ICommonActions>, requiredRole: string): boolean => {
    return store.state.userInfo?.role === requiredRole;
  },
  userHasMinRole: (store: Store<ICommonStore, ICommonActions>, minRole: roles): boolean => {
    const role = store.state.userInfo?.role;
    if (!role) return false;

    const roleValues = Object.values(roles);
    return roleValues.indexOf(role) >= roleValues.indexOf(minRole);
  },
  setActiveTab: (store: Store<ICommonStore, ICommonActions>, activeTab: number) => {
    store.setState({ ...store.state, activeTab });
  },
  setTabLength: (store: Store<ICommonStore, ICommonActions>, tabLength: number) => {
    store.setState({ ...store.state, tabLength });
  },
  tabNext: (store: Store<ICommonStore, ICommonActions>) => {
    if (typeof store.state?.activeTab === 'number' && store.state?.activeTab + 1 < store.state?.tabLength) {
      store.setState({ ...store.state, activeTab: store.state?.activeTab + 1 });
    }
  },
  tabBack: (store: Store<ICommonStore, ICommonActions>) => {
    if (typeof store.state?.activeTab === 'number' && store.state?.activeTab > 0) {
      store.setState({ ...store.state, activeTab: store.state?.activeTab - 1 });
    }
  },
  setSelectedSalesOrderIds: (store: Store<ICommonStore, ICommonActions>, selectedSalesOrderIds: string[]) => {
    store.setState({ ...store.state, selectedSalesOrderIds });
  },
};

/* Export */
const useCommonStore = globalHook<ICommonStore, ICommonActions>(initialCommonState, commonActions);

export default useCommonStore;
